import { render, staticRenderFns } from "./china.vue?vue&type=template&id=13f5208d&"
import script from "./china.vue?vue&type=script&lang=js&"
export * from "./china.vue?vue&type=script&lang=js&"
import style0 from "./china.vue?vue&type=style&index=0&id=13f5208d&prod&lang=less&less=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports